import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

//import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';

import { User } from './../models/user';
import { RestClient } from './rest.client';
@Injectable()
export class UserAuthenticationService extends RestClient{
	serverUrl: string;
	domainLink: string = "oauth/token";
	grantType:string;
	scope:string;
	constructor(public http:HttpClient) {
		super(http);
		this.serverUrl = environment.serverUrl;
		this.grantType = "easy_grant";
		this.scope = "*";
	}

	verifyOtp(data:any){
		return this.http.post(this.serverUrl+"api/otp/verify",data);
	}
	resendOtp(data:any){
		return this.http.post(this.serverUrl+"api/otp/resend",data);
	}
	
	updatePassword(data:any){
		return this.http.post(this.serverUrl+"api/user/saveChangePass",data);
	}
	requestCaptcha(){
		return this.http.get(this.serverUrl+"api/captcha/image");
	}
	
	getAuthUser(){
		return this.http.get(this.serverUrl+"api/userInitOtp", { headers: this.getHeaders() });
	}
	
	getUser(){
		return this.http.get(this.serverUrl+"api/user", { headers: this.getHeaders() });
	}
	
	authenticateUser(user:User){

		let formData: FormData = new FormData();
        formData.append("grant_type",this.grantType);
		formData.append("client_id",environment.auth_client_id.toString());
		formData.append("client_secret",environment.auth_client_secret);
		formData.append("username",user.email);
		formData.append("password",user.password);
		formData.append("scope",this.scope);
		formData.append("code",user.code);
		formData.append("code_id",user.code_id);
		
		return this.http.post(this.serverUrl+this.domainLink,formData);
	}
	
	logout() {
		localStorage.removeItem('user');
		localStorage.removeItem('isLoggedin');
		localStorage.removeItem('user_profile');
	}
}
